/**
 * Created by masoud on 05/05/17.
 */
import React from "react";
import createClass from "create-react-class";
import PropTypes from "prop-types";

require('../../../../../less/SnappFeatures.less');
const SnappFeatures = createClass({
    getInitialState() {
        return {
            currentTab: 0,
            pages: this.props.pages
        }
    },
    getDefaultProps() {
        return {
            pages: []
        }
    },
    render() {
        let self = this;
        let page = this.state.pages[this.state.currentTab];
        return <div className="Snapp-Features">
            <h2 className="F-Header">ویژگی‌های اسنپ</h2>
            <div className="Wrapper">
                <div className="Snapp-Features-Inner">
                    <div className="Tabs">
                        {this.props.pages.map((item, index) => {
                            return <div className={"Tab" + (self.state.currentTab === index ? " active" : "")}
                                        onClick={self.changePage.bind(self, index)}
                                        key={index}>
                                <i className={item.tab.icon}/><br/>
                                {item.tab.text}
                            </div>;
                        })}
                    </div>
                    <div className="Pages">
                        <div className="Image" style={{backgroundPosition: `0 ${page.content.image}px`}}>
                        </div>
                        <div className="Text">
                            <h2>{page.content.header}</h2>
                            <p className="Sub-Header">{page.content.subHeader}</p>
                            <p className="F-Text" dangerouslySetInnerHTML={{__html: page.content.text.replace(/\n/g, '<br/>')}}/>
                        </div>
                        <div className="Dots">
                            {this.state.pages.map((item, index) => {
                                return <div className={"Dot" + (index === self.state.currentTab ? " D-active" : "")}
                                            key={index} onClick={self.changePage.bind(self, index)}/>;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    },
    changePage(index) {
        this.setState({
            currentTab: index
        })
    }
});

SnappFeatures.propTypes = {
    pages: PropTypes.array
};

module.exports = SnappFeatures;


// WEBPACK FOOTER //
// ./src/js/components/Pages/MainPage/SnappFeatures/SnappFeatures.react.js